import React from 'react';
import { useNavigate } from 'react-router-dom';

const ComingSoon = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <div className="h-screen flex justify-center items-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">Exciting things are on the way! 🚀</h1>
        <p className="text-lg text-gray-600">We’re working hard to bring you something amazing. Stay tuned!</p>
        <button
          className="mt-12 px-8 py-2 bg-primary-600 hover:bg-primary-700 text-white font-bold rounded"
          onClick={goBack}
        >
          Go back
        </button>
      </div>
    </div>
  );
};

export default ComingSoon;
